import React from 'react'
import { Navigate } from 'react-router-dom'

const PrivateRoute = ({ element, path, role }) => {
  const getToken = () => localStorage.getItem('token')
  const token = getToken()
  let content

  if (token !== null && token !== 'undefined' && token) {
    if (role === 'admin') {
      if (path !== '/update') {
        content = <Navigate to="/update" />
      } else {
        content = element
      }
    } else {
      if (path === '/') {
        content = <Navigate to="/timesheet" />
      } else {
        content = element
      }
    }
  } else {
    content = (
      <Navigate to="/auth" />
    )
  }
  return content
}

export default PrivateRoute
